
import "./About.css";

import about from '../../assets/about2.jpg';
import {HiDownload} from "react-icons/hi";
import data from "./data";
import Card from "../../components/Card";

const About = () => {
  return (
   <section id="about">
    <div className=" container about_container">
    <div className="about_left">
      <div className="about_portrait">
        <img src={about} alt="AboutImage" />
      </div>

    </div>
    <div className="about_right">
      <h2>About Me</h2>
      <div className="about_cards">
        {
          data.map(item=>(
            <Card key={item.id} className="about_card">
              <span className="about_card-icon"> {item.icon}</span>
              <h5>{item.title}</h5>
              <small>{item.des}</small>
            </Card>
          ))
        }
      </div>

      <p>
      A self-motivated, hard-working, and ambitious Web Developer with proficiency in MERN Stack.
       Developing websites using Javascript, React, Redux, and Chakra UI.
      
      </p>
      
      <p>
      Looking forward to working as an accountable and competent employee in an exciting Tech company.
      </p>

      <a href= "https://drive.google.com/uc?export=download&id=1giMIqhzTMpIwHhyw1a8erKHpxeRfOuZr"  download className="btn primary">Download CV <HiDownload/></a>
    </div>
    </div>
   </section>
  )
}

export default About